import { StyleSheet } from 'aphrodite';
import { FontFamilies } from '../../../web/styles/styles';
import { SettingsCardType } from '../../models/setting';
import { brandPrimaryLight, green, hotPink, orange } from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	agentTemplates: {
		backgroundColor: '#8E44AD',
		backgroundImage: 'linear-gradient(135deg, #8E44AD 0%, #C39BD3 100%)',
	},
	blitzes: {
		background: green,
	},
	categories: {
		background: hotPink,
	},
	dashAndReports: {
		background: orange,
	},
	emailSignature: {
		background: brandPrimaryLight,
	},
	emailTemplates: {
		background: orange,
	},
	gamification: {
		background: brandPrimaryLight,
	},
	goals: {
		background: green,
	},
	manageUsers: {
		background: brandPrimaryLight,
	},
	password: {
		background: brandPrimaryLight,
	},
	phoneNumbers: {
		background: green,
	},
	salesAi: {
		backgroundColor: '#00DBDE',
		backgroundImage: 'linear-gradient(135deg, #00DBDE 0%, #FC00FF 100%)',
	},
	callAnalysis: {
		backgroundColor: '#667EEA',
		backgroundImage: 'linear-gradient(135deg, #667EEA 0%, #764BA2 100%)',
	},
	salesAiTester: {
		backgroundColor: '#00DBDE',
		backgroundImage: 'linear-gradient(135deg, #00DBDE 0%, #FC00FF 100%)',
	},
	transcriptionTest: {
		backgroundColor: '#00DBDE',
		backgroundImage: 'linear-gradient(135deg, #00DBDE 0%, #FC00FF 100%)',
	},
	settingsCard: {
		':hover': {
			boxShadow: `0 5px 14px 4px rgba(0, 0, 0, 0.2)`,
			transform: 'scale(1.05)',
		},
		...aidaBaseStyles.flexCenter,
		borderRadius: 10,
		color: '#fff',
		fontFamily: FontFamilies.conqueror,
		fontSize: '54px',
		height: 250,
		margin: '22.5px 12px',
		padding: '50px 40px',
		textAlign: 'center',
		textDecoration: 'none',
		transition: '.2s ease-in-out',
		width: 400,
	},
	settingsCardsContainer: {
		...aidaBaseStyles.flexHorizontalCenter,
		alignItems: 'stretch',
		flexWrap: 'wrap',
		justifyContent: 'space-around',
	},
	[SettingsCardType.PrizesLog]: {
		background: brandPrimaryLight,
	},
	[SettingsCardType.SlotMachinePrizes]: {
		background: orange,
	},
	[SettingsCardType.SlotMachines]: {
		background: brandPrimaryLight,
	},
	startABlitz: {
		background: green,
	},
	utilities: {
		background: brandPrimaryLight,
	},
	voicemail: {
		background: brandPrimaryLight,
	},
});
